import { createFileRoute } from '@tanstack/react-router'
import LoginPage from '#/pages/LoginPage'

export const Route = createFileRoute('/_auth/login')({
  component: LoginPage,
  head: () => ({
    meta: [
      { title: "Sign In — Wa'allamah" },
      {
        name: 'description',
        content:
          "Sign in to your Wa'allamah account to access your live classes, assignments, and learning materials.",
      },
    ],
  }),
})
